export default "__VITE_ASSET__CftapYFq__"